import NoImageSrc from "@/assets/images/no_image.svg";
import { CLink } from "@/components/common/customLink/CustomLink";
import CldImage from "@/components/ui/cldImg/CldImage";
import { getCloudinaryURL } from "@/utils/cloudinary";
import { BrandsDoubleCardProps } from "./types";

const BrandsDoubleCard = ({ data, altText }: BrandsDoubleCardProps) => {
  return (
    <div className="min-w-0 flex-none">
      <CLink href={data[0].link?.url ?? "#"} className="flex h-24 w-32 items-center justify-center">
        {/* <CldImg
          props={{
            src: images[0],
            alt: "logo",
            height: 96,
            width: 128,
          }}
        /> */}
        <CldImage
          src={getCloudinaryURL(data[0].media) ?? NoImageSrc}
          alt={altText?.[0] ?? "logo"}
          width={144}
          height={144}
        />
      </CLink>

      <CLink href={data[1].link?.url ?? "#"} className="flex h-24 w-32 items-center justify-center">
        {/* <CldImg
          props={{
            src: images[1],
            alt: "logo",
            height: 96,
            width: 128,
          }}
        /> */}
        <CldImage
          src={getCloudinaryURL(data[1].media) ?? NoImageSrc}
          alt={altText?.[1] ?? "logo"}
          width={144}
          height={144}
        />
      </CLink>
    </div>
  );
};

export default BrandsDoubleCard;